import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import { BundleApi } from "../../../../../../../../../../services/Api/Organization/types";
import BundlePreview from "../../components/BundlePreview/BundlePreview";

interface MatchParams {
	bundleId: string;
}

const OrganizationBundlePreviewPage = () => {
	const [bundle, setBundle] = useState<BundleApi | undefined>();
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>();
	const { addFlash } = useFlash();
	const { bundleId } = useParams<MatchParams>();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { t } = useTranslation();

	useEffect(() => {
		fetchBundle();
	}, []);

	const fetchBundle = async () => {
		try {
			const params = {
				include:
					"source_stock,destination_stock,custom_fields,items,items.product,items.items,items.items.product,tags,attachments,contact",
			};
			const customFieldsParams = {
				f: btoa(`${NEW_WAY_TO_ENCODING_FILTER_SIGN}resource_type|e=TRANSFER_ORDER`),
			};

			const requests: [Promise<BundleApi>, Promise<CustomFieldTemplateApi[]>] = [
				apiOrganization.getBundle(Number(bundleId), params),
				apiOrganization.getCustomFields(customFieldsParams),
			];
			const [bundleResponse, customFieldsResponse] = await Promise.all(requests);
			setBundle(bundleResponse);
			setCustomFieldsConfig(customFieldsResponse);
			handleChangeTabTitle(`${bundleResponse.document_number} | ${t("modules.bundle.header.title")}`);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!customFieldsConfig || !bundle) return <LoadingContainer />;

	return <BundlePreview bundle={bundle} customFieldsConfig={customFieldsConfig} setBundle={setBundle} />;
};

export default OrganizationBundlePreviewPage;
